export default __webpack_public_path__ + "static/media/18-stakeholder-map.dce569dd.png";